import * as yup from "yup";

export const dialogValidationSchema = yup.object().shape({
    firstName: yup.string().required('First Name is empty'),
    lastName: yup.string().required('Last Name is empty'),
    email: yup.string().email('Email format appears invalid').required('Email is empty'),
    phoneNumber: yup
        .string()
        .matches(/^\d{10}$/, 'Phone should be exactly 10 digits')
        .required('Phone Number is empty'),
    contactDate: yup.date().nullable().required('Contact Date is empty'),
    dba: yup.string().required('DBA is empty'),
    city: yup.string().required('City is empty'),
    state: yup.string().required('State is empty'),
    zipCode: yup
        .string()
        .matches(/^\d{5}$/, 'Zip Code should be 5 digits')
        .required('Zip Code is empty'),
    address: yup.string().required('Address is empty'),
    questions: yup.string().default(''),
    answers: yup.string().default(''),
    status: yup.string().default(''),
});

export interface EditAffiliateLead {
    id: number;
    contactDate: Date | null;
    firstName: string;
    lastName: string;
    city: string;
    state: string;
    zipCode: string;
    phoneNumber: string;
    email: string;
    questions: string;
    answers: string;
    status: string;
    dba: string;
    address: string;
}

export interface AffiliateLeadEditDialogProps {
    open: boolean;
    handleClose: () => void;
    lead: EditAffiliateLead | null;
    onSave?: (data: Omit<EditAffiliateLead, 'id'>) => void;
    onDelete?: () => void;
}

export interface AffiliateLead extends EditAffiliateLead {
  contactDate: Date;
  isApproved: boolean;
  createdAt: Date;
  uploadedAt: Date;
  markedForUploadAt: Date;
  uploadTarget?: string;
}